import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL, SITE_NAME, OG_IMAGE } from "@/constants/site";

// Centralised SEO: per-page title, description, canonical, Open Graph, Twitter
// card, and optional schema.org JSON-LD (object or array).
export default function Seo({ title, description, path = "", image = OG_IMAGE, type = "website", jsonLd }) {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
